import { ADD_TO_CART, REMOVE_FROM_CART } from '../types';
import { notification } from '../../utils';

export const addToCart = (product, qty) => async (dispatch, getState) => {
  const { items } = getState().cartItems;
  const cartItems = items.slice();
  const findItem = cartItems.find((item) => item._id === product._id);
  if (findItem) {
    qty ? (findItem.qty = qty) : findItem.qty++;
  } else {
    cartItems.push({ ...product, qty: qty || 1 });
  }

  dispatch({
    type: ADD_TO_CART,
    payload: cartItems,
  });

  localStorage.setItem('shopprs_cartItems', JSON.stringify(cartItems));
  itemsRemoved(product, 'add');

  notification('success', `${product.name} added!`);
};

export const removeFromCart = (product) => async (dispatch, getState) => {
  const { items } = getState().cartItems;
  const cartItems = items.slice().filter((i) => i._id !== product._id);
  dispatch({
    type: REMOVE_FROM_CART,
    payload: cartItems,
  });
  localStorage.setItem('shopprs_cartItems', JSON.stringify(cartItems));
  itemsRemoved(product, 'remove');

  notification('success', `${product.name} removed!`);
};

const itemsRemoved = (product, type) => {
  let cartItemsRemoved =
    JSON.parse(localStorage.getItem('shopprs_cartItemsRemoved')) ?? [];

  if (type === 'remove') {
    const findItem = cartItemsRemoved.find(
      (item) => item.productId === product._id
    );

    if (!findItem) {
      cartItemsRemoved.push({
        productId: product._id,
        productName: product.name,
      });
    }
  }

  if (type === 'add') {
    const findItem = cartItemsRemoved.find(
      (item) => item.productId === product._id
    );

    if (findItem) {
      cartItemsRemoved = cartItemsRemoved.filter(
        (item) => item.productId !== product._id
      );
    }
  }

  localStorage.setItem(
    'shopprs_cartItemsRemoved',
    JSON.stringify(cartItemsRemoved)
  );
};
